import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";

export const useAdderCardViewModel = ({ stateManager, data }) => {
  const [adderData, setAdderData] = useState({
    items: [],
    categories: [],
    areas: [],
  });

  const getDataHelper = (service, key, sort) => {
    stateManager.run(async () => {
      const response = await service.getAll({
        sort,
        filters: { id: { in: data.dependsOn } },
      });
      if (response.status === HTTP_STATUSES.OK) {
        setAdderData((prev) => ({ ...prev, [key]: response.data }));
      }
    });
  };

  const getAdderItems = () =>
    getDataHelper(homeService.materials, "items", {
      category: ["categoryName", "itemCode"],
    });

  const getAdderCategories = () =>
    getDataHelper(homeService.categories, "categories", "name");

  const getAdderAreas = () =>
    getDataHelper(homeService.areaTypes, "areas", "name");

  const getAdderData = () => {
    getAdderItems();
    getAdderCategories();
    getAdderAreas();
  };

  return {
    adderData,
    getAdderData,
  };
};
